import { useQueryState, parseAsBoolean } from 'nuqs'

type Actions = {
  toggle: VoidFunction
  close: VoidFunction
  open: VoidFunction
}

export type UseQueryDisclosureReturnType = [boolean, Actions]

export const useQueryDisclosure = (queryKey: string, defaultValue?: boolean): UseQueryDisclosureReturnType => {
  const [value, setValue] = useQueryState(queryKey, parseAsBoolean.withDefault(Boolean(defaultValue)))

  return [
    value,
    {
      toggle: () => setValue((prev) => !prev),
      open: () => setValue(true),
      close: () => setValue(false),
    },
  ]
}
